<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates46">
<p class="centerImage"><img alt="images" id="plate46" src="images/plate46.jpg"/></p>
<p class="caption">Final dining-in night at Ringway, as 3613 Squadron disbands in 1958. RWF and Sir Roy Dobson of A V Roe who was Honorary Air Commodore of 3613.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates46.vue?4cb48058